<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="datetime-box mResult">
      <van-field :label="field.options.label" :disabled="field.options.disabled" :required="field.options.required" readonly clickable :value="fieldModel"
        :placeholder="field.options.placeholder" @click="show" :input-align="field.options.textAlign" />
      <van-popup v-model="showPicker" round position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" :title="field.options.title" :min-date="minDate"
          :max-date="maxDate" @confirm="confirm" @cancel="cancel" />
      </van-popup>
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import moment from "moment";
import { isNull } from "@/utils/util";

export default {
  name: "datetimePickerWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      showPicker: false,
      fieldModel: "",
      rules: [],
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
      currentDate: new Date()
    };
  },
  components: {
    FormItemWrapper,
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initEventHandler();

    this.handleOnCreated();

    // this.buildFieldRules();
    this.syncUpdateFormModel("");
    this.buildFieldRules();
    if (this.field.options.required) {
      this.rulesF();
    }
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },
  watch: {
    fieldModel(val) {
      if(!val){
        this.fieldModel=''
      }else{
        let time = val
        this.currentDate = new Date(val)
        this.fieldModel=moment(time).format('YYYY-MM-DD')
      }
    },
  },

  methods: {
    show(){
      this.showPicker =!this.field.options.disabled
    },
    confirm(value) {
      this.currentDate = moment(value).format('YYYY-MM-DD')
      this.fieldModel = moment(value).format('YYYY-MM-DD');
      this.dispatch("ElFormItem", "el.form.change", [this.fieldModel]);
      this.handleChangeEvent(this.fieldModel);
      this.handleBlurCustomEvent(this.fieldModel);
      this.showPicker = false
    },
    cancel() {
      this.showPicker = false
    },
    rulesF() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (isNull(value)) {
            _this.aa()

            callback(new Error(
              _this.aa()
            ));
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

.area-input {
  height: 36px;
  border: 1px solid #ccc;
  padding-left: 10px;
}

::v-deep .el-form-item {
  display: flex;

  align-items: center;

  .el-form-item__content {
    margin-left: 0 !important;
    width: 100%;
  }

  .el-form-item__label {
    flex-shrink: 0
  }
}
</style>
